import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

const InternalMenu = ({ slice }) => {
  return (
    <section className='component-internal_menu mx-auto w-full max-w-screen-xl px-4 py-10 lg:py-20'>
      <ul className='flex flex-wrap justify-around'>
        {slice.items.map((link, index) => {
          return (
            <li className='md:w-auto flex flex-col flex-1 whitespace-nowrap' key={`link-${index}`}>
              <a className='flex flex-col h-full p-2 gap-4' href={link.link_id}>
                {link?.image?.gatsbyImageData && <GatsbyImage className='aspect-square rounded-md' image={link.image.gatsbyImageData} alt={link.image.alt || ''} />}
                <div className='mx-auto w-full button button-brand mt-auto text-center font-semibold text-xl'>{link.link_text}</div>
              </a>
            </li>
          )
        })}
      </ul>
    </section>
  )
}

export default InternalMenu
